export default interface Insurer {
  id: number;
  name: string;
}

export const isInsurer = (value: unknown): value is Insurer => {
  return !!value && typeof value === "object" && 'id' in value && 'name' in value;
};
